module.exports = __webpack_public_path__ + "img/guileme-1.ae7ca34e.png";